<script setup lang="ts">
import { ref } from 'vue';
import { MarkdownLineClamp } from '@alphadoc/alphadoc-text-clamp';
import UiTooltip from '@/modules/ui/components/ui/UiTooltip.vue';

const {
  markdown,
  text,
  maxLines = 1,
  onlyMouse,
} = defineProps<{
  markdown: string;
  text: string;
  maxLines?: number;
  onlyMouse?: boolean;
}>();

const MARKDOWN_OPTIONS = { linkify: false };

const isClamped = ref(false);

function onClampchange(clamped: boolean) {
  isClamped.value = clamped;
}
</script>

<template>
  <UiTooltip
    is="span"
    class="ui-clamped-text"
    :text="text"
    :disabled="!isClamped"
    :only-mouse="onlyMouse"
  >
    <MarkdownLineClamp
      :markdown="markdown"
      :max-lines="maxLines"
      :options="MARKDOWN_OPTIONS"
      @clampchange="onClampchange"
    />
  </UiTooltip>
</template>

<style scoped lang="scss">
.ui-clamped-text {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  padding: 0;
  white-space: normal;
  word-break: break-word;
}
</style>
